import {createPromisedAction} from '/util/action.util';

export const RESET_COACH_PROFILE: string = 'RESET_COACH_PROFILE';
export const RESET_CLIENT_PROFILE: string = 'RESET_CLIENT_PROFILE';

export const resetClientProfile = createPromisedAction(RESET_CLIENT_PROFILE, [
  'clientId',
  'data',
]);

export const resetCoachProfile = createPromisedAction(RESET_COACH_PROFILE, [
  'coachId',
  'data',
]);
